module.exports = __webpack_public_path__ + "img/DE02908.9971bae7.png";